import { Component } from '@angular/core';
import {
    CmpsDialogRef,
    CmpsSnackBar,
    CmpsTextOnlySnackBarComponent,
    CmpsTextOnlySnackBarOptions,
} from '@cmps/ng-uikit';
import { tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../../../common/take-until-destroy.decorator';
import { currentBuilderState } from '../../builder.state';
import { deletePreset } from '../../function/delete-preset.function';
import { filterPresets } from '../../function/filter-presets.function';
import { loadPreset } from '../../function/load-preset.function';
import { reset } from '../../function/reset.function';
import { updateRouterQueryParams } from '../../function/update-router-query-params.function';
import { BuilderState } from '../../model/builder-state.model';
import { PresetView } from '../../model/preset-view.model';
import { SelectionService } from '../../service/selection.service';

@Component({
    selector: 'cmps-report-builder-presets-dialog',
    templateUrl: './presets-dialog.component.html',
})
@TakeUntilDestroy()
export class PresetsDialogComponent {
    /** @private */
    _state: BuilderState;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            PresetsDialogComponent,
            void
        >,
        private readonly _selectionService: SelectionService,
        private readonly _snackBar: CmpsSnackBar,
    ) {
        this._state = currentBuilderState();
    }

    /** @private */
    _onKeywordChange(keyword: string | null): void {
        this._state.presetKeywords = keyword;
        filterPresets();
    }

    /** @private */
    _onLoadClick(preset: PresetView): void {
        reset();
        loadPreset(preset);
        updateRouterQueryParams();
        this._selectionService.onLoadPreset();
        this._dialogRef.close();
    }

    /** @private */
    _onDeleteClick(preset: PresetView): void {
        preset.deleting = true;

        deletePreset(preset.presetId)
            .pipe(
                tap((ret) => {
                    preset.deleting = false;

                    if (!ret) {
                        return;
                    }

                    const data: CmpsTextOnlySnackBarOptions = {
                        text: 'Deleted',
                    };

                    this._snackBar.open(CmpsTextOnlySnackBarComponent, {
                        duration: 2500,
                        placement: 'bottom-right',
                        data,
                    });
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
